var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"log"},[_c('div',{staticClass:"log_box fl1",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.goIndex()}}},[_vm._v(_vm._s(_vm.times)+"s 跳过")])])
}
var staticRenderFns = []

export { render, staticRenderFns }